import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { services } from '../data/mockData';
import { Flower2, Clock, Sparkles } from 'lucide-react';

const Detente = () => {
  const navigate = useNavigate();

  const handleReserve = (serviceName) => {
    navigate(`/reservation?service=${encodeURIComponent(serviceName)}`);
  };

  return (
    <div className="page-service">
      {/* Hero Header */}
      <section className="service-hero">
        <div className="service-hero-pattern" />
        <div className="service-hero-content">
          <h1 className="service-hero-title">Gamme Détente</h1>
          <Flower2 className="hero-icon" size={48} strokeWidth={1.5} />
          <p className="service-hero-description">
            Nos massages signature pour un moment de relaxation profonde 
            et un bien-être absolu
          </p>
        </div>
      </section>

      {/* Services List */}
      <section className="service-list-section">
        <div className="container-service">
          {services.detente.map((service, index) => (
            <div key={service.id} className="service-item">
              <div className="service-item-content">
                <div className="service-item-header">
                  <Sparkles className="service-icon" size={24} />
                  <div>
                    <h2 className="service-item-title">{service.name}</h2>
                    <div className="service-item-duration">
                      <Clock size={16} />
                      <span>{service.duration}</span>
                    </div>
                  </div>
                </div>
                
                <p className="service-item-description">{service.description}</p>
                
                <div className="service-item-footer">
                  <div className="service-price-info">
                    <span className="service-price-label">Tarif première visite :</span>
                    <span className="service-price-first">{service.firstVisitPrice}€</span>
                  </div>
                  <button
                    onClick={() => handleReserve(service.name)}
                    className="btn-reserve-service"
                  >
                    Réserver
                  </button>
                </div>
              </div>
              
              <div className="service-item-price">
                <div className="price-badge">
                  <span className="price-amount">{service.price}€</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <div className="service-cta-content">
          <h3 className="service-cta-title">Laissez-vous emporter par la détente</h3>
          <p className="service-cta-text">
            RDV en privé ou dans le lien dans ma bio
          </p>
          <Link to="/reservation" className="btn-primary">
            Réserver maintenant
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Detente;
